import { VueMaskDirective } from "v-mask";
const maskV2 = VueMaskDirective;
export const maskV3 = {
  beforeMount: maskV2.bind,
  updated: maskV2.componentUpdated,
  unmounted: maskV2.unbind,
};
